// removed by extract-text-webpack-plugin
module.exports = {"container":"_5UfNq","emptyStates":"jYMLO"};


//////////////////
// WEBPACK FOOTER
// ./app/components/restriction-private-member/restriction-private-member.scss
// module id = 1551
// module chunks = 0